import React from "react";

const Footer = ({ fecha }) => (
  <footer className="footer" id="footer">
    <p>Todos los derechos reservados &copy; {fecha}</p>
  </footer>
);

export default Footer;
